export class SignInPhoneNotfoundError extends Error {
  public constructor() {
    super()

    this.message = 'errors.signInPhoneNotfoundError'
  }
}
